<div class="space-y-5">
  <!-- Cancellation Context Card -->
  <div class="p-3.5 bg-surface-high border border-border rounded-xl space-y-2">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <lucide-icon name="alert-triangle" class="w-4 h-4 text-warning"></lucide-icon>
        <app-text size="sm" class="font-medium text-foreground">Cancellation Details</app-text>
      </div>
      <app-badge
        [title]="load.view?.tonuDecision?.status === 'eligible' ? 'TONU Eligible' : (load.view?.tonuDecision?.status === 'not_applicable' ? 'Waived' : 'Decision Pending')"
        [variant]="load.view?.tonuDecision?.status === 'eligible' ? 'success' : (load.view?.tonuDecision?.status === 'not_applicable' ? 'secondary' : 'warning')"
        badgeStyle="soft"
      ></app-badge>
    </div>

    <div class="text-xs text-muted space-y-1">
      <div class="flex justify-between">
        <span>Counterparty:</span>
        <span class="font-medium text-foreground">{{ load.view?.bookedFromCompanyName || load.view?.brokerName || load.view?.customerName || 'Unknown' }}</span>
      </div>
      @if (originalBookedRate > 0) {
        <div class="flex justify-between">
          <span>Original Booked Rate:</span>
          <span class="font-medium text-muted line-through">{{ originalBookedRate | currency }}</span>
        </div>
      }
      @if (load.view?.tonuDecision?.reason) {
        <div class="flex justify-between">
          <span>Reason:</span>
          <span class="font-medium text-foreground">{{ load.view?.tonuDecision?.reason }}</span>
        </div>
      }
      @if (load.view?.tonuDecision?.cancelledAt) {
        <div class="flex justify-between">
          <span>Cancelled At:</span>
          <span class="font-medium text-foreground">{{ $any(load.view?.tonuDecision?.cancelledAt)?.toDate() | date:'MMM d, y, h:mm a' }}</span>
        </div>
      }
    </div>
  </div>

  @if (!canEditBilling()) {
    <div class="p-3 bg-surface border border-warning rounded-xl flex items-center gap-3 text-xs text-warning">
      <lucide-icon name="shield-alert" class="w-4 h-4 shrink-0"></lucide-icon>
      <app-text size="xs" color="warning">
        Only Root, Admin, or Accounting team members are authorized to approve or modify billing and TONU decisions.
      </app-text>
    </div>
  }

  <!-- Decision Form -->
  <form [formGroup]="form" (ngSubmit)="save()" class="space-y-4">
    <app-form-field label="TONU Decision" [required]="true">
      <app-button-group
        [options]="decisionOptions"
        formControlName="decision"
        class="w-full"
      ></app-button-group>
    </app-form-field>

    @if (isEligible) {
      <app-form-field label="TONU Billable Fee" hint="Standard agreed fee with broker/customer for cancelled dispatch" [required]="true">
        <app-number-input
          currency="USD"
          [showGrouping]="true"
          formControlName="amount"
          [min]="0"
          placeholder="150.00"
          size="md"
        ></app-number-input>
      </app-form-field>
    }

    <app-form-field label="Decision Notes & Broker Justification" hint="Notes regarding why TONU was granted or waived">
      <app-input
        formControlName="notes"
        placeholder="e.g. Broker cancelled 30 mins after driver arrived at shipper; rate con updated."
        size="md"
      ></app-input>
    </app-form-field>

    <!-- Actions -->
    <div class="flex items-center justify-end gap-3 pt-3 border-t border-border">
      <app-button
        type="button"
        variant="ghost"
        (click)="close()"
        [disabled]="isSaving()"
      >
        Cancel
      </app-button>
      <app-button
        type="submit"
        variant="primary"
        [loading]="isSaving()"
        [disabled]="form.invalid || !canEditBilling() || isSaving()"
        icon="check"
      >
        Save Decision
      </app-button>
    </div>
  </form>
</div>
